import React from 'react';
import PropTypes from 'prop-types';
import { ClassName } from "mgToolsKit";

class ToggleButton extends  React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            checked : this.props.on
        }
    }

    componentDidMount() {

    } 

    onSelectCandidatesClick() {
        if(typeof this.props.OnClick == 'function'){
            this.props.OnClick(this.state.checked, !this.state.checked);
        }
        
        var newState = !this.state.checked;
        this.setState({
            checked: newState
        });
    }

    render() {
        var _classes  = ['mg-switch'];
        if(this.props.small){
            _classes.push("mg-switch-min");
        }
        if(this.props.classNames != ""){
            _classes.push(this.props.classNames);
        }
        var _classesOn = ["fa"];
        _classesOn.push(this.props.icons.on);
        var _classesOff = ["fa"];
        _classesOff.push(this.props.icons.off);
        return (
            <>
                <label id="mg-switch-theme-wrap" className={ClassName(_classes)}>
                    <input onChange={() => this.onSelectCandidatesClick()} id="mg-switch-theme" type="checkbox" 
                    checked={this.state.checked}  />
                    <span className="mg-switch-slider round">
                        <i className={ClassName(_classesOff)} aria-hidden="true"></i>
                        <i className={ClassName(_classesOn)} aria-hidden="true"></i>
                    </span>
                </label>
            </>
            );
    }
    /*
    getSnapshotBeforeUpdate(prevProps) {
        
        console.log(prevProps.on);
        console.log(this.props.on)
        return { changeSelected: prevProps.on !== this.props.on };
      }
      */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.on !== this.props.on) {
            this.setState({
                checked: this.props.on
            });
        }
    }
}
ToggleButton.propTypes = {
    small: PropTypes.bool,
    on: PropTypes.bool,
    icons: PropTypes.object,
    OnClick: PropTypes.func,
    classNames: PropTypes.string
};

ToggleButton.defaultProps = {
    small: false,
    classNames: "",
    on: false,
    icons:{
        on: "",
        off: ""
    },
    OnClick: ()=>{}
};

export default ToggleButton;